import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useMerchantAuth } from '../../../contexts/AuthContext';

const MESSAGES = {
    no_merchant: {
        title: 'Account setup incomplete',
        body: 'We could not find a store linked to your account. Try signing out, then log in again. If you just registered, contact support and we can finish your setup.',
    },
    api_error: {
        title: 'Could not load your account',
        body: 'We had trouble loading your merchant profile. Check your connection and refresh the page. If this keeps happening, contact support.',
    },
    access_removed: {
        title: 'No Merchant Access',
        body: 'Your access to this merchant has been removed. If you believe this is an error, please contact your administrator.',
    },
};

export default function NoAccessPage() {
    const { logout } = useAuth();
    const { noAccessReason } = useMerchantAuth();
    const navigate = useNavigate();
    const copy = MESSAGES[noAccessReason] || MESSAGES.access_removed;

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#0D0221] p-4">
            <div className="max-w-md w-full bg-[#14052e] rounded-xl p-8 border border-white/10 text-center">
                <h1 className="text-xl font-bold text-white mb-4">{copy.title}</h1>
                <p className="text-gray-400 mb-6">{copy.body}</p>
                <button
                    onClick={handleLogout}
                    className="w-full py-3 bg-[#00FFD0] text-[#0D0221] font-bold rounded-lg hover:opacity-90"
                >
                    Sign out
                </button>
            </div>
        </div>
    );
}
